import { render, staticRenderFns } from "./PowerBIConfig.vue?vue&type=template&id=2699fcac&"
import script from "./PowerBIConfig.vue?vue&type=script&lang=js&"
export * from "./PowerBIConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports